import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import "./style.scss";
import * as Assets from "../../utils/svg_assets";
import ApiUtils from "../../utils/api_utils";

const RedeemModal = (props) => {
  const {
    redeemtioType,
    children,
    show,
    redeemptionImage,
    redeemptionName,
    redeemptionTitle,
    redeemptionPoint,
  } = props;
  let param = {
    title: "",
    description: "",
  };

  switch (redeemtioType) {
    case "mobile_topup":
      param = {
        title: "VOUCHER REDEMPTION",
        description:
          "Please enter phone number recipient. Make sure the phone number are registered.",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          {param.description && (
            <div className="description">{param.description}</div>
          )}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "data_topup":
      param = {
        title: "VOUCHER REDEMPTION",
        description:
          "Please enter phone number recipient. Make sure the phone number are registered.",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          {param.description && (
            <div className="description">{param.description}</div>
          )}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "electricity_topup":
      param = {
        title: "Enter PLN Number",
        description: "Please enter PLN Number to redeem this Topup",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          {param.description && (
            <div className="description">{param.description}</div>
          )}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "e_voucher":
      param = {
        title: "Redeem This Reward",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          <Row className="icon-modal">
            <Col xs={4} sm={4} md={4}>
              <img
                src={ApiUtils.validateImgUrl({ url: redeemptionImage })}
                className="img-modal"
                alt="redeem-img"
              />
            </Col>
            <Col className="voucher-info">
              <Row>
                <Col className="voucher-name">{redeemptionName}</Col>
              </Row>
              {/* <Row>
								<Col className='voucher-description'>
									<div dangerouslySetInnerHTML={{ __html: redeemptionDescription }}/>
								</Col>
							</Row> */}
              <Row>
                <Col xs={2} sm={2} md={2}>
                  <img
                    src={Assets.iconOval}
                    width="20px"
                    height="20px"
                    alt="oval"
                  />
                </Col>
                <Col>{redeemptionPoint} Point Required</Col>
              </Row>
            </Col>
          </Row>
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "voucher_topup":
      param = {
        title: "Redeem This Reward",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          <Row className="icon-modal">
            <Col xs={4} sm={4} md={4}>
              <img
                src={ApiUtils.validateImgUrl({ url: redeemptionImage })}
                className="img-modal"
                alt="redeem-img"
              />
            </Col>
            <Col className="voucher-info">
              <Row>
                <Col className="voucher-name">{redeemptionName}</Col>
              </Row>
              {/* <Row>
								<Col className='voucher-description'>
									<div dangerouslySetInnerHTML={{ __html: redeemptionDescription }}/>
								</Col>
							</Row> */}
              <Row>
                <Col xs={2} sm={2} md={2}>
                  <img
                    src={Assets.iconOval}
                    width="20px"
                    height="20px"
                    alt="oval"
                  />
                </Col>
                <Col>{redeemptionPoint} Point Required</Col>
              </Row>
            </Col>
          </Row>
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "new_evoucher":
      param = {
        title: "Redeem This Reward",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          <Row className="icon-modal">
            <Col xs={4} sm={4} md={4}>
              <img
                src={ApiUtils.validateImgUrl({ url: redeemptionImage })}
                className="img-modal"
                alt="img-modal"
              />
            </Col>
            <Col className="voucher-info">
              <Row>
                <Col className="voucher-name">{redeemptionName}</Col>
              </Row>
              {/* <Row>
								<Col className='voucher-description'>
									<div dangerouslySetInnerHTML={{ __html: redeemptionDescription }}/>
								</Col>
							</Row> */}
              <Row>
                <Col xs={2} sm={2} md={2}>
                  <img
                    src={Assets.iconOval}
                    width="20px"
                    height="20px"
                    alt="oval"
                  />
                </Col>
                <Col>{redeemptionPoint} Point Required</Col>
              </Row>
            </Col>
          </Row>
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "giftn":
      param = {
        title: "Redeem This Reward",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          <Row className="icon-modal">
            <Col xs={4} sm={4} md={4}>
              <img
                src={ApiUtils.validateImgUrl({ url: redeemptionImage })}
                className="img-modal"
                alt="img-modal"
              />
            </Col>
            <Col className="voucher-info">
              <Row>
                <Col className="voucher-name">{redeemptionName}</Col>
              </Row>
              {/* <Row>
								<Col className='voucher-description'>
									<div dangerouslySetInnerHTML={{ __html: redeemptionDescription }}/>
								</Col>
							</Row> */}
              <Row>
                <Col xs={2} sm={2} md={2}>
                  <img
                    src={Assets.iconOval}
                    width="20px"
                    height="20px"
                    alt="oval"
                  />
                </Col>
                <Col>{redeemptionPoint} Point Required</Col>
              </Row>
            </Col>
          </Row>
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "gopay":
      param = {
        title: "GOPAY REDEMPTION",
        description:
          "Please enter gopay phone number recipient. Make sure the phone number are registered in gopay account.",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          {param.description && (
            <div className="description">{param.description}</div>
          )}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "balance_topup":
      param = {
        title: `${redeemptionTitle} REDEMPTION`,
        description: `Please enter ${redeemptionTitle} phone number recipient. Make sure the phone number are registered in ${redeemptionTitle} account.`,
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          {param.description && (
            <div className="description">{param.description}</div>
          )}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "flash":
      param = {
        title: "Redeem This Reward",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          <Row className="icon-modal">
            <Col xs={4} sm={4} md={4}>
              <img
                src={ApiUtils.validateImgUrl({ url: redeemptionImage })}
                className="img-modal"
                alt="img-modal"
              />
            </Col>
            <Col className="voucher-info">
              <Row>
                <Col className="voucher-name">{redeemptionName}</Col>
              </Row>
              <Row>
                <Col xs={2} sm={2} md={2}>
                  <img
                    src={Assets.iconOval}
                    width="20px"
                    height="20px"
                    alt="oval"
                  />
                </Col>
                <Col>{redeemptionPoint} Point Required</Col>
              </Row>
            </Col>
          </Row>
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    case "flash_password":
      param = {
        title: "VENDOR PASSCODE",
        description:
          "Please provide correct passcode by entering manually on the field below or scanning qr code provided.",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          {param.description && (
            <div className="description">{param.description}</div>
          )}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
    default:
      param = {
        title: "Redeem This Reward",
      };

      return (
        <Modal
          onHide={!show}
          show={show}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          {param.title && <Modal.Title>{param.title}</Modal.Title>}
          <Row className="icon-modal">
            <Col xs={4} sm={4} md={4}>
              <img
                src={ApiUtils.validateImgUrl({ url: redeemptionImage })}
                className="img-modal"
                alt="redeem-img"
              />
            </Col>
            <Col className="voucher-info">
              <Row>
                <Col className="voucher-name">{redeemptionName}</Col>
              </Row>
              {/* <Row>
								<Col className='voucher-description'>
									<div dangerouslySetInnerHTML={{ __html: redeemptionDescription }}/>
								</Col>
							</Row> */}
              <Row>
                <Col xs={2} sm={2} md={2}>
                  <img
                    src={Assets.iconOval}
                    width="20px"
                    height="20px"
                    alt="oval"
                  />
                </Col>
                <Col>{redeemptionPoint} Point Required</Col>
              </Row>
            </Col>
          </Row>
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      );
  }
};

export default RedeemModal;
